import { ThemesDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { InventoryListControllerModule } from './controllers/InventoryListController';

export const InventoryListView = angular
  .module('acme.view.application.inventory.list', [uiRouter, 'ui.bootstrap', InventoryListControllerModule])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.inventory.list',
      url: '/list',
      views: {
        'subview-main': {
          controller: 'InventoryListController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/inventory/list/list.tpl.html',
        },
      },
      data: {
        pageTitle: 'Inventory',
      },
      resolve: {
        ThemesData: ThemesDataResolver({ includeEmail: true }),
      },
    });
  }).name;
